import styled from 'styled-components';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Label } from '@progress/kendo-react-labels';
import { EditError, EditInput, OpenSansSemiBoldLabelMod } from '../../index.sc';
import exclamation from '../../../../images/exclamation.png';

const ErrorImage = styled.img`
  height: 17px;
  margin-left: 8px;
  width: 17px;
`;

const ErrorMessage = styled(EditError)`
  font-size: 14px;
`;

export const FormInput = (fieldRenderProps: any) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    type,
    optional,
    ...others
  } = fieldRenderProps;
  const showValidationMessage = touched && validationMessage;
  const errorId = showValidationMessage ? `${id}_error` : '';

  return (
    <FieldWrapper>
      <div className="tw-flex tw-items-center tw-gap-1">
        <OpenSansSemiBoldLabelMod
          as={Label}
          editorId={id}
          editorDisabled={disabled}
          optional={optional}
        >
          {label}
        </OpenSansSemiBoldLabelMod>
        {optional && (
          <span className="tw-text-xs tw-font-normal tw-text-unum-neutral-500 tw-mb-3">
            (optional)
          </span>
        )}
      </div>
      <div className="mb-3">
        <EditInput
          ariaDescribedBy={`${errorId}`}
          disabled={disabled}
          id={id}
          type={type}
          valid={valid}
          {...others}
        />
        {showValidationMessage && (
          <div className="tw-flex tw-items-center tw-mt-1">
            <ErrorImage src={exclamation} alt="" />
            <ErrorMessage
              className="ml-1"
              id={errorId}
              style={{ fontSize: '14px' }}
            >
              {validationMessage}
            </ErrorMessage>
          </div>
        )}
      </div>
    </FieldWrapper>
  );
};
